module.exports = __webpack_public_path__ + "static/img/iconShadowMoon.34da910.svg";


//////////////////
// WEBPACK FOOTER
// ./static/svg/iconShadowMoon.svg
// module id = 2bXi
// module chunks = 1